import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import { useDispatch, useSelector } from "react-redux";

export default function UpdatePassportRenewal({ data, setPopUp, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    new_passport_no: "",
    new_passport_issue_date: "",
    new_passport_expiry_date: "",
    renewal_fees: "",
    borne_by: "",
  });
  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };
  const token = localStorage.getItem("nodeToken");
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await nodeinstance.post(
        "/passport-renewal/UpdatePassport",
        {
          employee_id: data.employee_id,
          new_passport_no: formData.new_passport_no,
          new_passport_issue_date: formData.new_passport_issue_date,
          new_passport_expiry_date: formData.new_passport_expiry_date,
          renewal_fees: formData.renewal_fees,
          borne_by: formData.borne_by,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status == true) {
        setPopUp(false);
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        onSuccess();
      } else {
        console.log("response to be printed in the console",res)
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
    setLoading(false);
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">
              {" "}
              Update Passport Renewal Details
            </h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={submitHandler}
            className="w-full flex flex-col my-4 gap-3"
          >
            <div className="flex flex-col gap-1">
              <label className="text-sm">New Passport Number</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                defaultValue={formData?.name?.toUpperCase()}
                placeholder="Enter Passport Number"
                name="newPassportNumber"
                required
                onChange={(e) =>
                  setFormData({ ...formData, new_passport_no: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">New Passport Issue Date</label>
              <input
                type="date"
                onKeyDown={handleKeyDown}
                id="field2"
                className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
                required
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    new_passport_issue_date: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">New Passport Expiry Date</label>
              <input
                type="date"
                onKeyDown={handleKeyDown}
                id="field2"
                min= {formData.new_passport_issue_date}
                className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
                required
                disabled = {formData.new_passport_issue_date === ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    new_passport_expiry_date: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Renewal Fee</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                required
                onChange={(e) =>
                  setFormData({ ...formData, renewal_fees: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Borne By</label>
              <div className="flex items-center space-x-8">
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="SLA"
                    onChange={(e) =>
                      setFormData({ ...formData, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">SLA</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Client"
                    onChange={(e) =>
                      setFormData({ ...formData, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Client</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Employee"
                    onChange={(e) =>
                      setFormData({ ...formData, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Employee</span>
                </label>
              </div>
            </div>

            <div className="flex  gap-3 mx-auto my-3 w-full px-5">
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
